export const ACTION_GET_MENU_USER_COMPANY = "ACTION_GET_MENU_USER_COMPANY";